module.exports = "/images/bg@2x.jpg?82077d990393189b3e2fbe1a5f317990";